import React from 'react';

const BackgroundFooterMenu = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="375"
      height="293"
      viewBox="0 0 375 293"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M64.5833 232.433C45.3125 232.986 0 225.703 0 225.703C0 225.703 52.0833 251.069 129.167 251.069C291.515 251.069 375 126.311 375 126.311V0C375 0 298.958 225.703 64.5833 232.433Z"
        fill="#008774"
      />
      <path
        d="M0 293H375V126.311C375 126.311 291.515 251.069 129.167 251.069C52.0833 251.069 0 225.703 0 225.703V293Z"
        fill="#008774"
      />
      <path
        d="M0 293H375V126.311C375 126.311 291.515 251.069 129.167 251.069C52.0833 251.069 0 225.703 0 225.703V293Z"
        fill="#127547"
      />
    </svg>
  );
};

export default BackgroundFooterMenu;
